/**
 * build non-GET url with params
 *
 * @example replaceParamsInUrl('/api/user/:userId/report', { userId: '123', startDate: '2025-01-01' })
 * // will return ['/api/user/123/report', { startDate: '2025-01-01' }]
 */
export function replaceParamsInUrl(
    url: string,
    params: Record<string, any>
): [string, Record<string, any>] {
    // replace route placeholders with actual values, like /api/user/:userId
    const routePlaceholders: string[] = [];
    const replacedUrl = url.replace(/:(\w+)/g, (match, routePlaceholder) => {
        routePlaceholders.push(routePlaceholder);
        const paramValue = params[routePlaceholder];
        return paramValue !== undefined ? paramValue : match;
    });

    const bodyData: Record<string, any> = {};
    Object.entries(params).forEach(([key, value]) => {
        // skip route placeholders
        if (routePlaceholders.includes(key)) {
            return;
        }
        bodyData[key] = value;
    });

    return [replacedUrl, bodyData];
}

/**
 * build GET url with params
 *
 * @example appendParamsToUrl('/api/user/:userId/report', { userId: '123', startDate: '2025-01-01' })
 * // will return '/api/user/123/report?startDate=2025-01-01'
 */
export function appendParamsToUrl(url: string, params: Record<string, any>): string {
    const [replacedUrl, bodyData] = replaceParamsInUrl(url, params);
    const searchParams = new URLSearchParams(bodyData);

    return `${replacedUrl}?${searchParams.toString()}`;
}
